<template>
  <v-autocomplete
    :id="`search-icd10-code-${props.data.searchId}`"
    v-model="selectedItem"
    class="lh--force-white-background"
    :items="items"
    :label="props.data.label + (props.required ? '*' : '')"
    placeholder="Start typing ICD-10 Code or Diagnosis"
    :disabled="props.disabled"
    :clearable="true"
    :return-object="true"
    :loading="loading"
    :search="typedText"
    :min-chars="3"
    @update:search="handleSearch"
    @update:model-value="handleSelection"
    @keyup.esc="cleanInput">
    <template #item="{ props: itemProps, item }">
      <v-list-item v-bind="itemProps">
        <v-list-item-title> {{ item.raw.code }} - {{ item.raw.diagnosis }} </v-list-item-title>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script setup>
import { ref, computed } from "vue";
import axios from "axios";
import debounce from "lodash.debounce";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["icd10-selected"]);

const selectedItem = ref(null);
const typedText = ref("");
const loading = ref(false);
const suggestions = ref([]);
const icd10CodeServiceQueryURL = "https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search?sf=code,name&df=code,name";

const items = computed(() => {
  return suggestions.value.map((item) => ({
    title: `${item[0]} - ${item[1]}`,
    value: { code: item[0], diagnosis: item[1] },
    raw: { code: item[0], diagnosis: item[1] },
  }));
});

const handleSearch = debounce(async (search) => {
  typedText.value = search;
  if (search && search.length >= 3) {
    loading.value = true;
    try {
      const url = `${icd10CodeServiceQueryURL}&terms=${search}`;
      const result = await axios.get(url).then((res) => res.data);
      suggestions.value = result[3].map((item) => [item[0], item[1]]);
    } catch (error) {
      suggestions.value = [];
    } finally {
      loading.value = false;
    }
  } else {
    suggestions.value = [];
  }
}, 500);

function handleSelection(item) {
  if (item) {
    emit("icd10-selected", { name: item.value.diagnosis, icd10Code: item.value.code });
  }
}

function cleanInput() {
  selectedItem.value = null;
  typedText.value = "";
  suggestions.value = [];
}
</script>

<style lang="scss" scoped>
@import "../styles/pages/_patient-information-form.scss";
</style>
